import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, Grid, TextField } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { FormLesoesTraumaticas } from 'views/ExamesRealizados/ExameNecroscopico/LesoesTraumaticas/FormLesoesTraumaticas'
import { FormFenomenosCadavericos } from 'views/ExamesRealizados/ExameNecroscopico/FenomenosCadavericos/FormFenomenosCadavericos'
import { CustomButton, SecaoGenerica } from 'components'
import { useStyles } from './FormAnaliseCadavericaLocal.styles'
import { useFormAnaliseCadavericaLocal } from './hooks/useFormAnaliseCadavericaLocal'

export const FormAnaliseCadavericaLocal = ({ idCadaver, fetchCadaveres, idExameRealizado, onConfirmSuccess }) => {
  const classes = useStyles()
  const {
    processandoAnaliseCadaverica,
    processandoConfirmacao,
    values,
    handleChange,
    handleAutocompleteChange,
    handleSalvarInformacoesCadaver,
    hasError,
    errors,
    setLesoes,
  } = useFormAnaliseCadavericaLocal({
    idCadaver,
    fetchCadaveres,
    idExameRealizado,
    onConfirmSuccess,
  })

  return (
    <div>
      {processandoAnaliseCadaverica ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div className={classes.detailPanel}>
          <Grid container spacing={2} className={classes.containerCampos}>
            <SecaoGenerica titulo="Informações gerais do cadáver" spacing={2}>
              <Grid item md={12} sm={12} xs={12} className={classes.field}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Localização do cadáver na cena do caso"
                  name="localizacao"
                  onChange={handleChange}
                  value={values.localizacao || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                  error={hasError('localizacao')}
                  helperText={hasError('localizacao') ? errors.localizacao : null}
                />
              </Grid>
              <Grid item md={6} sm={6} xs={12} className={classes.field}>
                <AutocompleteNative
                  value={values.posicao || null}
                  name="posicao"
                  noOptionsText="Sem informações"
                  options={[
                    'DECÚBITO DORSAL',
                    'DECÚBITO VENTRAL',
                    'DECÚBITO LATERAL ESQUERDO',
                    'DECÚBITO LATERAL DIREITO',
                    'POSIÇÃO FETAL',
                    'SENTADO',
                    'SUSPENSÃO COMPLETA',
                    'SUSPENSÃO INCOMPLETA',
                    'GENUPEITORAL',
                    'OUTRO',
                  ]}
                  onChange={(event, newValue) => {
                    handleAutocompleteChange('posicao', newValue)
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      error={hasError('posicao')}
                      label="Posição"
                      required
                      helperText={hasError('posicao') ? errors.posicao : null}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>
              {values.posicao === 'OUTRO' && (
                <Grid item md={6} sm={6} xs={12} className={classes.field}>
                  <TextField
                    value={values.posicaoInputText || ''}
                    variant="outlined"
                    fullWidth
                    label="Outra posição (selecione a opção 'outro')"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={handleChange}
                    name="posicaoInputText"
                  />
                </Grid>
              )}
              <Grid item md={4} sm={4} xs={12} className={classes.field}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Cicatrizes"
                  name="cicatrizes"
                  onChange={handleChange}
                  value={values.cicatrizes || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item md={4} sm={4} xs={12} className={classes.field}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Tatuagens"
                  name="tatuagens"
                  onChange={handleChange}
                  value={values.tatuagens || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item md={4} sm={4} xs={12} className={classes.field}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Vestimentas"
                  name="vestimentas"
                  onChange={handleChange}
                  value={values.vestimentas || ''}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </SecaoGenerica>

            <SecaoGenerica titulo="Fenômenos cadavéricos">
              <FormFenomenosCadavericos idExameRealizado={idExameRealizado} idCadaver={idCadaver} />
            </SecaoGenerica>

            <SecaoGenerica titulo="Lesões traumáticas e outros itens">
              <Grid item md={12} sm={12} xs={12}>
                <FormLesoesTraumaticas
                  idExameRealizado={idExameRealizado}
                  idCadaver={idCadaver}
                  setLesoesForm={setLesoes}
                />
              </Grid>
            </SecaoGenerica>

            <Grid item md={12} sm={12} xs={12} className={classes.botaoSalvar}>
              <CustomButton
                variant="contained"
                color="primary"
                disabled={!values.posicao || processandoConfirmacao}
                isLoading={processandoConfirmacao}
                onClick={handleSalvarInformacoesCadaver}
              >
                SALVAR INFORMAÇÕES DO CADÁVER
              </CustomButton>
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  )
}

FormAnaliseCadavericaLocal.propTypes = {
  idCadaver: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fetchCadaveres: PropTypes.func.isRequired,
  idExameRealizado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}
